import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { TopicServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin Topic Master section
 */
const useListTopic = ([page_no], onSuccess, onError = onDefaultError) => {
  return useQuery(["topic-list", page_no], TopicServices.TopicList, {
    onSuccess,
    keepPreviousData: true,
    onError,
  });
};
const useAddTopic = (onSuccess, onError = onDefaultError) => {
  return useMutation(TopicServices.addTopic, {
    onSuccess,
    onError,
  });
};
const useTopicDelete = (onSuccess, onError = onDefaultError) => {
  return useMutation(TopicServices.deleteTopic, {
    onSuccess,
    onError,
  });
};
const useViewTopic = (id, onSuccess, onError = onDefaultError) => {
  return useQuery("topic-view", () => TopicServices.viewTopic({ id }), {
    onSuccess,
    onError,
  });
};
const useUpdateTopic = (onSuccess, onError = onDefaultError) => {
  return useMutation(TopicServices.updateTopic, {
    onSuccess,
    onError,
  });
};
const useTopicStatusChange = (onSuccess, onError = onDefaultError) => {
  return useMutation(TopicServices.updateStatusTopic, {
    onSuccess,
    onError,
  });
};
export { useListTopic, useTopicDelete, useTopicStatusChange, useAddTopic,useUpdateTopic,useViewTopic};
